import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-sparkle, document, locked, password"><path d="M4.75 11.75V2.75H12.75L19.25 9.25V21.25H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 2.75V9.25H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M6.4 14H5.6L4.6 16.6L2 17.6V18.4L4.6 19.4L5.6 22H6.4L7.4 19.4L10 18.4V17.6L7.4 16.6L6.4 14Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFileSparkle;
